import React from 'react'

import axios from 'axios'

import { uniqueDmps } from '../../lib/format-dmps'

// props:
// @dmp value
// @dmpProduct value
// @dmpProductDescription value
//
// onDmpChange()
// onDmpProductChange()
export default class DMPFilter extends React.Component {
    state = {
        dmpList: [],
        dmpProducts: [],
        showProducts: true,
        showLabels: true
    }

    loadDmpList() {
        axios.get('/dmpDetails').then(response => {
            console.log('dmp list', response, response.data.body)

            let data = response.data.body
            if(this.props.hideArDmp && this.props.hideArDmp === 'true'){
                data = data.filter(el => el.dmp !== 'ar')
            }


            this.setState(
                {
                    dmpList: uniqueDmps(
                        data,
                        this.props.showAllProductOption && this.props.showAllProductOption === 'true',
                        this.props.showPleaseSelectOption && this.props.showPleaseSelectOption === 'true'
                    ),
                    dmpProducts: []
                },
                () => {
                    console.log('this.state.showProducts ' + this.props.showProducts)
                    if (this.props.showProducts) {
                        return
                    }

                    if (this.props.dmp) {
                        this.loadDmpDetails(this.props.dmp)
                    } else {
                        this.props.onDmpChange(this.state.dmpList[0].dmp)
                        this.loadDmpDetails(this.state.dmpList[0].dmp)
                    }
                }
            )
        })
    }

    loadDmpDetails(dmpName) {
        axios.get('/dmpDetails?dmp=' + dmpName).then(response => {
            console.log('dmp product list', response, response.data.body)

            // add on top "All" option to use an empty filter
            if (this.props.showAllProductOption == 'true') {
                response.data.body.unshift({ dmp: '', dmpName: '', hasPartner: true, product: '', productName: 'All' })
            }

            console.log('load details this.props', this.props)

            this.setState({ dmpProducts: response.data.body }, () => {
                if (this.state.dmpProducts && this.state.dmpProducts.length > 0) {
                    console.log('this.props.dmpProduct', this.props.dmpProduct)
                    // trigger event selection
                    if (this.props.dmpProduct) {
                        //this.props.onDmpProductChange(this.props.dmpProduct, '' + true)
                    } else {
                        if (this.props.onDmpProductChange) {
                            this.props.onDmpProductChange(
                                this.state.dmpProducts[0].product,
                                '' + this.state.dmpProducts[0].hasPartner,
                                this.state.dmpProducts[0].description
                            )
                        }
                    }
                }
            })
        })
    }

    componentDidMount() {
        console.log('dmp filter props: ', this.props)

        let obj = {}
        if (this.props.showProducts != undefined) {
            obj['showProducts'] = this.props.showProducts
        }
        if (this.props.showLabels != undefined) {
            obj['showLabels'] = this.props.showLabels
        }

        // set in 1 call all props -> in state
        if (obj && Object.keys(obj).length > 0) {
            this.setState(obj, () => {
                this.loadDmpList()
            })
        } else {
            this.loadDmpList()
        }
    }

    render() {
        return (
            <div className="row">
                <div className={this.state.showProducts == true ? 'col-6' : 'col-12'}>
                    <div>
                        {this.state.showLabels == true && <p style={{ marginTop: 30 }}>Marketplace</p>}

                        <select
                            disabled={this.props.disable}
                            className="form-control"
                            value={this.props.dmp}
                            onChange={({ target }) => {
                                this.props.onDmpChange(target.value)
                                console.log('on dmp change ', target.value)
                                console.log('on dmp change this.state.showProducts ', this.state.showProducts)
                                if (this.state.showProducts == true) this.loadDmpDetails(target.value)
                            }}>
                            {this.state.dmpList &&
                                this.state.dmpList.map(item => {
                                    return (
                                        <option key={item.dmp} value={item.dmp}>
                                            {item.dmpName}
                                        </option>
                                    )
                                })}
                        </select>
                    </div>
                </div>
                {this.state.showProducts == true && (
                    <div className="col-6">
                        <div>
                            {this.state.showLabels == true && <p style={{ marginTop: 30 }}>Product</p>}

                            <select
                                disabled={this.props.disable}
                                className="form-control"
                                value={this.props.dmpProduct}
                                onChange={({ target }) => {
                                    if (target) {
                                        console.log('***on product change ', target)
                                        console.log('***on product change haspartner ', target.selectedOptions[0].getAttribute('haspartner'))
                                        console.log('***on product change description ', target.selectedOptions[0].getAttribute('description'))
                                        this.props.onDmpProductChange(
                                            target.value,
                                            target.selectedOptions[0].getAttribute('haspartner'),
                                            target.selectedOptions[0].getAttribute('description')
                                        )
                                    }
                                }}>
                                {/*(this.props.showAllProductOption == "true") && (
                                    <option key="all" value="">All</option>
                                )*/}
                                {this.state.dmpProducts.map(item => {
                                    return (
                                        <option
                                            key={item.productName}
                                            description={'' + item.description}
                                            haspartner={'' + item.hasPartner}
                                            value={item.product}>
                                            {item.productName}
                                        </option>
                                    )
                                })}
                            </select>

                            {this.props.dmpProductDescription &&
                                this.props.dmpProductDescription != '' &&
                                this.props.dmpProductDescription != undefined &&
                                this.props.dmpProductDescription != 'undefined' && (
                                    <div className="" style={{ fontSize: 'smaller', color: 'rgb(121,121,121)', paddingTop: '5px' }}>
                                        {this.props.dmpProductDescription}
                                    </div>
                                )}
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
